import React from "react";
import PropTypes from "prop-types";
import Link from "@/components/Link";
import { Alert as AlertType } from "@/components/proptypes";
import Tooltip from "@/components/Tooltip";
import InfoCircleFilledIcon from "@ant-design/icons/InfoCircleFilled";
import QuestionCircleTwoToneIcon from "@ant-design/icons/QuestionCircleTwoTone";
import { useTheme } from "@/components/ThemeProvider";

import "./Alert.less";

export default function AlertFormItem({ alert }) {
  const { isDarkMode } = useTheme();

  const alertHint = (
    <small>
      {alert?.name ? (
        <>
          <InfoCircleFilledIcon className="ok-icon" /> This alert is available in the alert list view.{" "}
          <Tooltip title="Go to the alert view to see the alert details."></Tooltip>
        </>
      ) : (
        <>
          <InfoCircleFilledIcon className="warning-icon-danger" /> This alert might have been deleted. Please get in touch wih an admin.{" "}
          <Tooltip title="Alert not found."></Tooltip>
        </>
      )}
    </small>
  );

  return (
    <div className={`alert-form-item ${isDarkMode ? 'dark-mode' : ''}`}>
      {alert?.name ? (
        <>
          <Tooltip title="Open alert in a new tab.">
            <Link href={`alerts/${alert.id}/overview`} target="_blank" rel="noopener noreferrer" className="alert-link">
              {alert.name} <i className="fa fa-external-link" aria-hidden="true" />
              <span className="sr-only">(opens in a new tab)</span>
            </Link>
          </Tooltip>
          <div className="ant-form-item-explain">{alert && alertHint}</div>
        </>
      ) : (
        <>
          <div className="ant-form-item-explain">
            <QuestionCircleTwoToneIcon className="warning-icon-danger" /> Not found.
          </div>
        </>
      )}
    </div>
  );
}

AlertFormItem.propTypes = {
  alert: AlertType,
  onChange: PropTypes.func,
  editMode: PropTypes.bool,
};

AlertFormItem.defaultProps = {
  alert: null,
  onChange: () => {},
  editMode: false,
};
